import React from "react";

/**
 * 🔹 MobileTitleSpacer — composant universel
 * Sert à créer un espace sous le mini-lecteur pour que les titres
 * soient alignés correctement sur mobile/tablette.
 *
 * Utilisation :
 *   <MobileTitleSpacer />                   // hauteur par défaut
 *   <MobileTitleSpacer height="176px" />    // pour ajuster selon la page
 */

export default function MobileTitleSpacer({ height = "160px" }) {
  return (
    <div
      className="block md:hidden"
      style={{ height }}
    />
  );
}
